import { useMutation, useQueryClient } from '@tanstack/react-query';
import { myPageService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';
import { bridge } from 'shared/src/utils';
import type { PatchMyInfoRequest } from 'shared/src/api/myPageService/patchMyInfo/types';

export const useUpdateMyInfo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PatchMyInfoRequest) => myPageService.patchMyInfo(data),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: queryKey.myInfo });
      await bridge.updateMemberMe(JSON.stringify({ refetch: false }));
    },
  });
};
